import * as Sentry from '@sentry/nextjs';

declare global {
  interface Window {
    utag_data?: {
      'cp.utag_main_v_id'?: string;
      'cp.s_ecid'?: string;
      'cp._cls_s'?: string;
    };
  }
}

export const MAX_TRIES = 3;
export const RETRY_WAIT_TIME = 1000;

interface SetSentryUserDataProps {
  iteration?: number;
  journeyName?: string;
}

export default function setSentryUserData({
  iteration = 1,
  journeyName,
}: SetSentryUserDataProps) {
  if (iteration > MAX_TRIES) return;

  if (typeof window.utag_data?.['cp.utag_main_v_id'] !== 'undefined') {
    const userId = window.utag_data['cp.utag_main_v_id'];

    Sentry.setUser({ id: userId });
    Sentry.setTag('tealiumVisitorId', userId);

    if (window.utag_data?.['cp.s_ecid']) {
      Sentry.setTag('adobeCloudID', window.utag_data?.['cp.s_ecid']);
    }

    if (window.utag_data?.['cp._cls_s']) {
      Sentry.setTag('glassBoxSessionId', window.utag_data?.['cp._cls_s']);
    }
    if (journeyName) {
      Sentry.setTag('journeyName', journeyName);
    }
  } else {
    setTimeout(() => {
      setSentryUserData({ iteration: iteration + 1, journeyName });
    }, RETRY_WAIT_TIME);
  }
}
